/* Panier A.M.A. : pop-up branché sur le panier Shopify (API AJAX), échantillon offert au choix */
(function () {
  'use strict';
  const fen = document.querySelector('[data-panier]');
  if (!fen) return;
  let D = { textes: {}, parfums: {}, fioles: [] };
  try { D = JSON.parse(fen.querySelector('[data-pan="donnees"]').textContent); } catch (e) {}
  const SEUIL = parseInt(fen.dataset.seuil, 10) || 7000, DELAI = parseInt(fen.dataset.delai, 10) || 3, ECH_MAX = parseInt(fen.dataset.echMax, 10) || 1;
  const R = (window.ama && window.ama.routes) || { cart: '/cart', add: '/cart/add', change: '/cart/change', update: '/cart/update' };
  const PROP = '_echantillon';
  const T = (window.ama && window.ama.t) || {}, LOC = (window.ama && window.ama.locale) || 'fr';
  let panier = null, occupe = false;
  // mot personnalisé (note native du panier) : ouvert ou non et texte saisi, conservés quand le panier se redessine
  let mot = null, motOuvert = null, motModifie = false, motMinuteur = null, motEnvoi = Promise.resolve();

  // prix : « 130 € » en euro (comme la maquette) ; dans une autre devise (marchés internationaux), format de la devise
  const eur = function (c) { const n = c / 100, dev = (panier && panier.currency) || 'EUR'; if (dev !== 'EUR') return n.toLocaleString(LOC, { style: 'currency', currency: dev, minimumFractionDigits: n % 1 ? 2 : 0 }); return n.toLocaleString(LOC, { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 }) + ' €'; };
  // éléments du thème (titre de l'échantillon, panier vide) rendus par la section dans des <template>
  const tpl = function (n) { const t = fen.querySelector('template[data-pan="' + n + '"]'); return t ? t.innerHTML : ''; };
  const paiement = ((window.ama && window.ama.routes && window.ama.routes.root) || '/').replace(/\/$/, '') + '/checkout';
  const esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  const estEch = function (l) { return l.properties && l.properties[PROP]; };
  function api(url, corps) {
    return fetch(url + '.js', corps ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(corps) } : { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }
  function charger() { return api(R.cart).then(function (c) { panier = c; rendre(); return c; }); }
  function livraisonLe() {
    const d = new Date(); let n = 0;
    while (n < DELAI) { d.setDate(d.getDate() + 1); if (d.getDay() % 6) n++; }
    return d.toLocaleDateString(LOC, { weekday: 'short', day: 'numeric', month: 'short' });
  }

  function motHtml() {
    if (!D.textes.mot) return '';
    const texte = mot !== null ? mot : (panier.note || '');
    const ouvert = motOuvert === null ? !!texte : motOuvert;
    return '<details class="pan-mot"' + (ouvert ? ' open' : '') + '><summary>' + esc(D.textes.mot) + '</summary><textarea data-mot rows="3" maxlength="500" aria-label="' + esc(D.textes.mot) + '" placeholder="' + esc(D.textes.motChamp) + '">' + esc(texte) + '</textarea></details>';
  }
  function enregistrerMot() {
    clearTimeout(motMinuteur);
    if (!motModifie) return motEnvoi;
    motModifie = false;
    const note = mot;
    motEnvoi = motEnvoi.then(function () {
      return fetch(R.update + '.js', { method: 'POST', keepalive: true, headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ note: note }) });
    }).catch(function () { motModifie = true; });
    return motEnvoi;
  }

  function rendre() {
    if (!panier) return;
    const lignes = panier.items.filter(function (l) { return !estEch(l); });
    const ech = panier.items.filter(estEch);
    const nb = lignes.reduce(function (s, l) { return s + l.quantity; }, 0);
    document.querySelectorAll('[data-compte-panier]').forEach(function (e) { e.textContent = nb; });
    const compte = fen.querySelector('[data-pan="compte"]'); if (compte) compte.textContent = nb ? '(' + nb + ')' : '';
    const corps = fen.querySelector('[data-pan="corps"]'), pied = fen.querySelector('[data-pan="pied"]');
    fen.classList.toggle('est-vide', !nb);
    if (!nb) {
      corps.innerHTML = '<div class="pan-vide"><div class="pan-vide-texte">' + tpl('vide') + '</div><a class="bouton noir" href="' + esc(D.textes.videLien) + '">' + esc(D.textes.videBouton) + '</a></div>';
      pied.innerHTML = '';
      const pageV = document.querySelector('[data-panier-page]');
      if (pageV) { pageV.innerHTML = '<div>' + corps.innerHTML + '</div>'; const b = document.getElementById('pan-barre'); if (b) b.hidden = true; }
      return;
    }
    const total = panier.total_price, reste = Math.max(0, SEUIL - total);
    const seuil = reste > 0
      ? '<div class="pan-seuil" aria-live="polite"><span>' + esc((T.cart_left || '').replace('[amount]', eur(reste))) + '</span><div class="pan-jauge"><i style="transform:scaleX(' + Math.min(1, total / SEUIL) + ')"></i></div></div>'
      : '<div class="pan-seuil ok" aria-live="polite"><svg viewBox="0 0 16 16" aria-hidden="true"><path d="M3 8.4l3 3 7-7.2"/></svg><span>' + esc(T.cart_free || '') + ' <small>· ' + esc((T.cart_estimated || '').replace('[date]', livraisonLe())) + '</small></span></div>';
    const html = lignes.map(function (l) {
      const info = D.parfums[l.product_id] || {};
      return '<li class="pan-ligne" data-cle="' + esc(l.key) + '"><figure>' + (l.image ? '<img src="' + esc(l.image) + '&width=240" alt="">' : '') + '</figure>' +
        '<p class="pan-nom"><a href="' + esc(l.url) + '">' + esc(info.nom || l.product_title) + '</a></p><span class="pan-prix">' + eur(l.final_line_price) + '</span>' +
        '<p class="pan-detail">' + esc(info.contenance || l.variant_title || '') + '</p>' +
        '<div class="pan-actions"><div class="pan-qte" role="group" aria-label="' + esc(T.cart_qty || '') + '"><button type="button" data-moins aria-label="' + esc(T.cart_remove_one || '') + '"' + (l.quantity <= 1 ? ' disabled' : '') + '>−</button><output aria-live="polite">' + l.quantity + '</output><button type="button" data-plus aria-label="' + esc(T.cart_add_one || '') + '">+</button></div>' +
        '<button class="pan-retirer" type="button" data-retirer>' + esc(T.cart_remove || '') + '</button></div></li>';
    }).join('');
    // échantillon offert seulement si le panier contient un flacon de la collection des parfums (pas pour la Discovery seule)
    const eligible = lignes.some(function (l) { return !!D.parfums[l.product_id]; });
    // fioles proposées : pas celles des parfums déjà dans le panier
    const exclues = {};
    const cles = {};
    lignes.forEach(function (l) { exclues[l.product_id] = 1; const info = D.parfums[l.product_id]; if (info && info.fiole) exclues[info.fiole] = 1; if (info && info.cle) cles[info.cle] = 1; });
    const choix = D.fioles.filter(function (f) { return f.dispo && !exclues[f.produit] && !(f.cle && cles[f.cle]); });
    const echHtml = eligible && choix.length ? '<section class="pan-ech" aria-labelledby="pan-ech-titre"><div class="pan-ech-titre" id="pan-ech-titre">' + tpl('ech') + (ECH_MAX > 1 ? '<span class="pan-ech-compte">' + ech.length + '/' + ECH_MAX + '</span>' : '') + '</div><div class="pan-choix">' + choix.map(function (f) {
      const pris = ech.some(function (l) { return l.variant_id === f.variante; });
      return '<button type="button" data-ech="' + f.variante + '" aria-pressed="' + !!pris + '"><span class="coche" aria-hidden="true"><svg viewBox="0 0 10 10"><path d="M2 5.2l2 2 4-4.4"/></svg></span>' + (f.image ? '<img src="' + esc(f.image) + '" alt="">' : '') + '<b>' + esc(f.nom) + '</b>' + (f.interprete ? '<small>' + esc(f.interprete) + '</small>' : '') + '</button>';
    }).join('') + '</div></section>' : '';
    corps.innerHTML = seuil + '<ul class="pan-lignes">' + html + '</ul>' + echHtml;
    pied.innerHTML = motHtml() + '<dl class="pan-totaux"><div class="total"><dt>' + esc(T.cart_total || '') + '</dt><dd>' + eur(total) + '</dd></div></dl><a class="bouton noir pan-commander" href="' + paiement + '">' + esc(D.textes.commander) + '</a>';
    const page = document.querySelector('[data-panier-page]');
    if (page) {
      page.innerHTML = '<div><ul class="pan-lignes">' + html + '</ul>' + echHtml + '<a class="pan-continuer" href="' + esc(D.textes.videLien) + '">' + esc(T.cart_continue || '') + '</a></div>' +
        '<aside class="pan-resume" aria-label="' + esc(T.cart_summary || '') + '"><p class="pan-resume-titre">' + esc(T.cart_summary || '') + '</p>' + seuil + motHtml() + '<dl class="pan-totaux"><div class="total"><dt>' + esc(T.cart_total || '') + '</dt><dd>' + eur(total) + '</dd></div></dl><a class="bouton noir pan-commander" href="' + paiement + '">' + esc(D.textes.commander) + '</a></aside>';
      const barre = document.getElementById('pan-barre'); if (barre) { barre.hidden = false; barre.querySelector('b').textContent = eur(total); }
    }
  }

  function agir(promesse) {
    if (occupe) return Promise.resolve();
    occupe = true; fen.classList.add('charge');
    return promesse.then(function () { return charger(); }).then(nettoyer).finally(function () { occupe = false; fen.classList.remove('charge'); });
  }
  // échantillons limités au nombre réglé, et seulement s'il reste un flacon de la collection des parfums
  function nettoyer() {
    if (!panier) return;
    const ech = panier.items.filter(estEch), flacons = panier.items.filter(function (l) { return !estEch(l) && !!D.parfums[l.product_id]; });
    const enTrop = flacons.length ? ech.slice(ECH_MAX) : ech;
    if (!enTrop.length) return;
    return enTrop.reduce(function (p, l) { return p.then(function () { return api(R.change, { id: l.key, quantity: 0 }); }); }, Promise.resolve()).then(charger);
  }
  function ouvrir() { if (!fen.open) { document.documentElement.classList.add('verrou'); fen.showModal(); fen.focus(); } }
  window.amaPanier = { ouvrir: ouvrir, charger: charger };

  document.addEventListener('click', function (e) {
    // commander : le mot est enregistré avant de partir au paiement
    const commander = e.target.closest('.pan-commander, .pan-barre a');
    if (commander && mot !== null) {
      e.preventDefault();
      enregistrerMot().then(function () { location.href = commander.href; });
      return;
    }
    const ajout = e.target.closest('[data-ajout-variante]');
    if (ajout) {
      e.preventDefault();
      if (ajout.disabled) return;
      ajout.classList.add('ok');
      agir(api(R.add, { items: [{ id: parseInt(ajout.dataset.ajoutVariante, 10), quantity: 1 }] })).then(ouvrir);
      return;
    }
    if (e.target.closest('[data-ouvrir-panier]')) {
      if (location.pathname.replace(/\/$/, '') === R.cart.replace(/\/$/, '')) return;
      e.preventDefault(); charger(); ouvrir(); return;
    }
    const surPage = e.target.closest('[data-panier-page]');
    if (!fen.contains(e.target) && !surPage) return;
    if (e.target.closest('.pan-fermer')) { fen.close(); return; }
    const motTitre = e.target.closest('.pan-mot summary');
    if (motTitre) {
      motOuvert = !motTitre.parentNode.open;
      if (motOuvert) setTimeout(function () { motTitre.parentNode.querySelector('[data-mot]').focus(); });
      return;
    }
    const ligne = e.target.closest('.pan-ligne');
    if (ligne) {
      const l = panier.items.filter(function (x) { return x.key === ligne.dataset.cle; })[0];
      if (!l) return;
      if (e.target.closest('[data-plus]')) agir(api(R.change, { id: l.key, quantity: l.quantity + 1 }));
      else if (e.target.closest('[data-moins]')) agir(api(R.change, { id: l.key, quantity: Math.max(1, l.quantity - 1) }));
      else if (e.target.closest('[data-retirer]')) agir(api(R.change, { id: l.key, quantity: 0 }));
      return;
    }
    const ch = e.target.closest('[data-ech]');
    if (ch) {
      // re-clic : retire l'échantillon ; nombre maximum atteint : le plus ancien laisse sa place au nouveau
      const v = parseInt(ch.dataset.ech, 10), pris = panier.items.filter(estEch);
      const deja = pris.filter(function (l) { return l.variant_id === v; })[0];
      const sortant = deja || (pris.length >= ECH_MAX ? pris[0] : null);
      let suite = Promise.resolve();
      if (sortant) suite = api(R.change, { id: sortant.key, quantity: 0 });
      if (!deja) {
        const prop = {}; prop[PROP] = 'offert';
        suite = suite.then(function () { return api(R.add, { items: [{ id: v, quantity: 1, properties: prop }] }); });
      }
      agir(suite);
    }
  });
  document.addEventListener('input', function (e) {
    if (!e.target.matches('[data-mot]')) return;
    mot = e.target.value; motModifie = true;
    document.querySelectorAll('[data-mot]').forEach(function (c) { if (c !== e.target) c.value = mot; });
    clearTimeout(motMinuteur); motMinuteur = setTimeout(enregistrerMot, 500);
  });
  document.addEventListener('change', function (e) { if (e.target.matches('[data-mot]')) enregistrerMot(); });
  window.addEventListener('pagehide', enregistrerMot);
  fen.addEventListener('close', function () { document.documentElement.classList.remove('verrou'); });
  charger();
})();
